export const PAGE_STATE = {
  INITIAL_LOADING: 'INITIAL_LOADING',
  LOADING: 'LOADING',
  LOADING_SUCCESS: 'LOADING_SUCCESS',
  LOADING_ERROR: 'LOADING_ERROR',
};
